module.exports = __webpack_public_path__ + "img/icon-dashboard.e4736afa.svg";